// Module
var code = "<h2 id=\"federal-loan-deferment--forbearance-forms\">Federal Loan Deferment &amp; Forbearance Forms</h2> <p>Apply for a deferment or forbearance to temporarily pause federal loan payments.</p> ";
// Exports
export default code;